import { version } from '../../package.json'

const EXCEPT_KEY = `${version}|`

export function getChache(key) {
    const cachedString = window.localStorage[key]

    if (!cachedString) {
        return null
    }
    if (cachedString.substr(0, EXCEPT_KEY.length) !== EXCEPT_KEY) {
        delete window.localStorage[key]

        return null
    }

    return JSON.parse(cachedString.substr(EXCEPT_KEY.length))
}

export function setChached(key, value) {
    window.localStorage[key] = EXCEPT_KEY + JSON.stringify(value)
}

export function setCacheDalayed(key) {
    let timeout = null

    return (value) => {
        if (timeout) {
            clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
            setChached(key, value)
        }, 1500)
    }
}
